import { Alert, Button, Divider, Form, message, Modal, Select, SelectProps, Space, Tag } from "antd";
import { useEffect, useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { useAuth } from "../../Contexts/AuthContext";
import { BookyInput } from "../Forms/BookyInput";
import { GroupService } from "../../Services/GroupService";
import { TextService } from "../../Services/TextService";
import { MemberService } from "../../Services/MemberService";
import { WebApiCompanyDtoCompanyDto, WebApiMemberDtoMemberDto, WebApiModelsEmailTemplate, WebApiModelsMemberField, WebApiServicesDataTransferObjectsGroupServiceGroupMemberDto, WebApiServicesDataTransferObjectsGroupServiceGroupResultDto, WebApiServicesDataTransferObjectsMemberServiceFilterLogic } from "../../Repository/eventbookyapi";
import FileSelect from "../Upload/UploadFile";
import { UploadChangeParam } from "antd/lib/upload";
import { BookyButton } from "../Buttons/BookyButton";
import { MemberAutocomplete } from "../AutoComplete/MemberAutocomplete";
import { MemberTable } from "../Table/MemberTable";
import { MemberPaymentStatus } from "../../Types/MemberPaymentStatus";
import { BookySelectPaymentStatus } from "../Forms/BookyPaymentStatusSelect";
import { EmailFormType } from "../../Types/EmailFormType";
import { OneFrontHtmlEditor } from "../Forms/OneFrontHtmlEditor";
import { CompanyService } from "../../Services/CompanyService";
import { BookySelectDropDown } from "../Forms/BookySelectDropDown";
import { ContactAutoComplete } from "../AutoComplete/ContactAutocomplete";
import { EmailTemplateService } from "../../Services/EmailTemplateService";
import { PaymentConfiguration } from "../../Types/PaymentConfiguration";
import { BookyCheckbox } from "../Forms/BookyCheckbox";
import { EmailNotificationPreference } from "../../Types/EmailNotificationPreference";
import { CheckCircleFilled, CheckCircleOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { FilterMemberType } from "../../Types/FilterMemberType";
import { AutoCompleteType } from "../../Types/AutoCompleteType";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";
import { MemberFieldService } from "../../Services/MemberFieldService";
import { FilterOperator } from "../../Types/FilterOperator";
import { AdvancedMemberFilter, FilterRequest } from "../Filters/AdvancedMemberFilter";
import { SubscriptionLevel } from "../../Types/SubscriptionLevel";

export const EmailForm = (props: any) => {
    const [form] = useForm();
    const [initialHtml, setInitialHtml] = useState("" as any);
    const [html, setHtml] = useState("" as any);
    const [externalEmails, setExternalEmails] = useState([] as any[]);
    const [subject, setSubject] = useState("" as string);
    const [editorKey, setEditorKey] = useState(0);
    const [emailIsvalid, setEmailIsValid] = useState(false as boolean);

    const [company, setCompany] = useState({} as WebApiCompanyDtoCompanyDto);

    const [loading, setLoading] = useState(false as boolean);
    const [showConfirm, setShowConfirm] = useState(false as boolean);
    const [selectedGroup, setSelectedGroup] = useState([] as number[]);
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(undefined as MemberPaymentStatus | undefined);

    const [fileResult, setFileList] = useState<UploadChangeParam>();
    const [isAllowedToSendGroupMails, setIsAllowedToSendGroupMails] = useState(true as boolean);
    const { user } = useAuth();
    const [selectedMembers, setSelectedMembers] = useState([] as WebApiMemberDtoMemberDto[]);
    const [memberFieldSettings, setMemberFieldSettings] = useState([] as WebApiModelsMemberField[]);
    const [currentFilterRequest, setCurrentFilterRequest] = useState<FilterRequest | undefined>(undefined);

    const GetText = TextService.GetText;

    useEffect(() => {
        if (props.groups != null && props.groups.length > 0) {
            setSelectedGroup(props.groups[0]);
            form.setFieldValue("group", props.groups[0].id)
        }

        CompanyService.GetCompany().then(company => {
            setCompany(company);
        })

        MemberFieldService.GetMemberFields().then(result => {
            setMemberFieldSettings(result);
        });

        GroupService.IsAllowedToSendGroupMails().then(result => {
            setIsAllowedToSendGroupMails(result.toString() === true.toString());
        });
    }, [props]);

    const containsParams = (htmlContent: string): boolean => {
        return htmlContent.indexOf('{{params.') !== -1;
    };

    const containsPaymentLinkParam = (htmlContent: string): boolean => {
        if (!htmlContent) return false;
        const lower = htmlContent.toLowerCase();
        // Swedish: {{params.betallänk}}, English: {{params.paymentlink}}
        return lower.includes('{{params.betallänk}}') || lower.includes('{{params.paymentlink}}');
    };

    const getMembersWithoutPaymentLink = (): WebApiMemberDtoMemberDto[] => {
        if (!containsPaymentLinkParam(html) || selectedMembers.length === 0) return [];
        return selectedMembers.filter(m => !m.paymentLink && !m.paymentLinkId);
    };

    const onReminderFinish = async (formValues: any) => {

        if (hasNoMembersOrEmails()) {
            message.warning("Du måste skicka till minst en medlem/e-postadress.");
            return;
        }

        if (htmlMessageIsEmpty(html)) {
            message.warning("Du måste skriva något i mailet.");
            return;
        }

        if (stringIsEmpty(subject)) {
            message.warning("Mailet måste ha ett ämne.");
            return;
        }

        if (props.type === EmailFormType.EmailFormByExternal && containsParams(html)) {
            message.error(GetText("EmailForm_CannotUseParamsExternal"));
            return;
        }

        setShowConfirm(true);
    };

    const onFileSelectChange = (files: any) => {
        setFileList(files);
    }

    const onFilterMembers = async (filterRequest?: FilterRequest) => {
        let filteredMembers: WebApiMemberDtoMemberDto[] = [];

        if (!selectedGroup.length) {
            message.warning(GetText("EmailForm_SelectOneGroup"));
            return;
        }

        // Prepare filters array - always include Email IsNotEmpty
        const baseFilters = filterRequest && filterRequest.filters.length > 0
            ? filterRequest.filters
            : [{ fieldName: "Email", operator: FilterOperator.IsNotEmpty }];

        // Map the filters to API format (converting logic from string to enum)
        const filters = baseFilters.map(filter => ({
            fieldName: filter.fieldName,
            operator: filter.operator,
            value: filter.value,
            logic: (filter.logic === 'Or' ? 1 : 0) as WebApiServicesDataTransferObjectsMemberServiceFilterLogic
        }));

        // If we have advanced filters, ensure Email is not empty is included
        if (filterRequest && filterRequest.filters.length > 0) {
            const hasEmailFilter = filters.some(f => f.fieldName === "Email" && f.operator === FilterOperator.IsNotEmpty);
            if (!hasEmailFilter) {
                filters.push({
                    fieldName: "Email",
                    operator: FilterOperator.IsNotEmpty,
                    value: undefined,
                    logic: 0 as WebApiServicesDataTransferObjectsMemberServiceFilterLogic
                });
            }
        }

        filteredMembers = await MemberService.GetFilteredMembers({
            status: selectedPaymentStatus,
            emailNotificationPreference: form.getFieldValue("emailNotificationPreference") == 0 || !form.getFieldValue("emailNotificationPreference") ? EmailNotificationPreference.Unspecified : EmailNotificationPreference.NoInformationEmails,
            isAllMembers: selectedGroup.length == 0 || selectedGroup.some(p => p == -1) ? true : false,
            groupsIds: selectedGroup,
            filters: filters
        });

        setSelectedMembers(filteredMembers);

        if (filteredMembers.length == 0) {
            message.warning("No members found.")
        }
    }

    const handleAdvancedFilterChange = (filterRequest: FilterRequest) => {
        // Just store the filter request, don't apply it yet
        setCurrentFilterRequest(filterRequest);
    };



    const onSendConfirmOK = async () => {
        setLoading(true);

        if (selectedMembers.length == 0) {
            message.error("Select at least one member");
            return;
        }

        var memberIds: number[] = selectedMembers.map(m => m.memberId!);

        try {
            await MemberService.SendEmailToMembers({
                subject: form.getFieldValue("subject"),
                message: html,
                files: getFileFromUploadControl(),
                memberIds: memberIds
            });
            message.success(GetText("EmailForm_EmailsSent"));
        } catch {
            message.error(GetText("EmailForm_EmailsSentFailed"))
        }

        setLoading(false);
        form.setFieldsValue({
            message: "",
            messageFromTemplate: "",
            subject: ""
        });
        setSubject("");
        setHtml("");
        setInitialHtml(undefined);
        setEditorKey(prev => prev + 1);
        setShowConfirm(false);
    };

    const getFileFromUploadControl = (): Blob[] => {
        var files: Blob[] = [];

        fileResult?.fileList.forEach((file: any) => {
            if (file.originFileObj) {
                files.push(file.originFileObj as Blob);
            }
            else {
                files.push(file as Blob);
            }
        });

        return files;
    }

    const onSendConfirmOKExternal = async () => {
        setLoading(true);

        if (externalEmails.length == 0) {
            message.error("Select at least one email");
            return;
        }

        try {
            await EmailTemplateService.SendMailToExternal({
                subject: form.getFieldValue("subject"),
                message: html,
                files: getFileFromUploadControl(),
                emails: externalEmails
            });
            message.success(GetText("EmailForm_EmailsSent"));
        } catch {
            message.error(GetText("EmailForm_EmailsSentFailed"))
        }

        setLoading(false);
        form.setFieldsValue({
            message: "",
            messageFromTemplate: "",
            subject: ""
        });
        setSubject("");
        setHtml("");
        setInitialHtml(undefined);
        setEditorKey(prev => prev + 1);
        setShowConfirm(false);
    }

    const onAutoCompleteSelect = (member: WebApiMemberDtoMemberDto) => {
        let newList: WebApiMemberDtoMemberDto[] = selectedMembers.map(p => p);
        if (!selectedMembers.some((e: WebApiMemberDtoMemberDto) => e.email === member.email)) {
            newList.push(member);
        }
        setSelectedMembers(newList);
    }

    const removeMember = (memberToRemove: WebApiServicesDataTransferObjectsGroupServiceGroupMemberDto) => {
        let newList = selectedMembers.filter(p => p.email != memberToRemove.email);
        setSelectedMembers(newList);
    };


    const groupOptions = () => {
        const options: SelectProps['options'] = [];

        props.groups.forEach((element: WebApiServicesDataTransferObjectsGroupServiceGroupResultDto) => {
            options.push({
                label: element.name,
                value: element.id,
            });
        });

        return options;
    }

    const emailTemplatesOptions = () => {
        const options: SelectProps['options'] = [];

        props.emailTemplates.forEach((element: WebApiModelsEmailTemplate) => {
            options.push({
                label: element.templateName,
                value: element.id,
            });
        });

        return options;
    }

    const handleGroupChange = async (value: number[]) => {
        setSelectedGroup(value);
    };

    const handleTemplateChange = async (value: number) => {
        let emailTemplate: WebApiModelsEmailTemplate[] = props.emailTemplates.filter((p: WebApiModelsEmailTemplate) => p.id === value);
        if (emailTemplate && emailTemplate.length > 0) {
            setInitialHtml(emailTemplate[0]?.body);
            setHtml(emailTemplate[0]?.body);
            setSubject(emailTemplate[0]?.subject || "");
            setEditorKey(prev => prev + 1);

            form.setFieldsValue({
                message: emailTemplate[0]?.body,
                messageFromTemplate: emailTemplate[0]?.body,
                subject: emailTemplate[0]?.subject
            });

            const emailContainsEmails = stringIsEmpty(emailTemplate[0]?.subject!) || htmlMessageIsEmpty(emailTemplate[0]?.body!);
            setEmailIsValid(!emailContainsEmails);
        }
        else {
            setInitialHtml(undefined);
            setSubject("");
            setEditorKey(prev => prev + 1);
            form.setFieldsValue({ subject: "" });
        }
    };

    const onSendConfirmCancel = async () => {
        setShowConfirm(false);
    };

    const onSelectPaymentChanged = async (value: MemberPaymentStatus) => {
        setSelectedPaymentStatus(value);
    };

    const onHtmlChange = (html: string) => {
        const emailContainsEmails = stringIsEmpty(subject) || htmlMessageIsEmpty(html);
        setEmailIsValid(!emailContainsEmails);
        form.setFieldValue("message", html);
        setHtml(html);
    }

    const onEmailsUpdated = async (onEmailsUpdated: any) => {
        setExternalEmails(onEmailsUpdated => ([
            ...onEmailsUpdated,
        ]));
    }

    const hasNoMembersOrEmails = () => {
        return (selectedMembers.length == 0 && externalEmails.length == 0)
    }

    const htmlMessageIsEmpty = (html: string) => {
        return html.length < 1 || html == "<p></p>"
    }

    const stringIsEmpty = (subject: string) => {
        return subject === "";
    }

    const onSubjectchange = (e: any) => {
        const emailContainsEmails = stringIsEmpty(e.target.value) || htmlMessageIsEmpty(html);
        setEmailIsValid(!emailContainsEmails);
        setSubject(e.target.value);
    }

    return <>
        <Modal
            title={GetText("EmailForm_ConfirmText")}
            open={showConfirm}
            onOk={props.type === EmailFormType.EmailFormByExternal ? onSendConfirmOKExternal : onSendConfirmOK}
            confirmLoading={loading}
            onCancel={onSendConfirmCancel}
        >
            {props.type === EmailFormType.EmailFormByExternal ?
                (GetText("EmailForm_ConfirmText1") + externalEmails.length + GetText("EmailForm_ConfirmText2")) :
                (GetText("EmailForm_ConfirmText1") + selectedMembers.length + GetText("EmailForm_ConfirmText2"))}
            {getMembersWithoutPaymentLink().length > 0 && (
                <Alert
                    style={{ marginTop: 12 }}
                    type="warning"
                    showIcon
                    icon={<ExclamationCircleFilled style={{ color: '#faad14' }} />}
                    message={GetText("EmailForm_PaymentLinkWarningConfirm").replace("{0}", getMembersWithoutPaymentLink().length.toString())}
                />
            )}
        </Modal>
        {user?.hasPaidSubscription ?
            <>
                {isAllowedToSendGroupMails === true ? <Form
                    form={form}
                    layout="vertical"
                    onFinish={onReminderFinish}
                    autoComplete="off"
                >
                    <Form.Item
                    >
                        {company && company.email && company.name ?
                            <>{GetText("EmailForm_From")} {company.name} {"<" + company.email + ">"}</> :
                            <>{GetText("EmailForm_From")} {user.firstName} {user.lastName} {"<" + user.email + ">"}</>}
                    </Form.Item>

                    <div style={{
                        backgroundColor: '#fafafa',
                        padding: '20px',
                        borderRadius: '8px',
                        border: '1px solid #e8e8e8',
                        marginBottom: '30px'
                    }}>
                        <h3>{!hasNoMembersOrEmails() ? <CheckCircleFilled style={{ color: "green" }} /> : <CheckCircleOutlined style={{ color: "grey" }} />} {GetText("EmailForm_Step1")}</h3>
                        <Divider style={{ marginTop: "5px" }} />
                        <span style={{ color: "red" }}>*</span> {GetText("EmailForm_ChooseReceiver")}
                        {props.type === EmailFormType.EmailFormByGroup && props.groups.length > 0 ? <><br />
                            <Select placeholder={GetText("EmailForm_ChooseCategories")} onChange={handleGroupChange} style={{ width: '400px', marginBottom: "10px" }} mode="multiple" options={groupOptions()}></Select>
                            <br /> {props.user.paymentConfiguration == PaymentConfiguration.YearlyPayments ? <BookySelectPaymentStatus showLastYearOptions={true} style={{ width: "400px" }} onSelectPaymentChanged={onSelectPaymentChanged} /> : ""}
                            <br /><BookyCheckbox alignLabelRight={true} label={"Skicka även till medlemmar som inte önskar e-post"} name="emailNotificationPreference"></BookyCheckbox>
                            {(user?.subscriptionLevel === SubscriptionLevel.Premium || user?.subscriptionLevel === SubscriptionLevel.Enterprise) && (
                                <AdvancedMemberFilter
                                    memberFieldSettings={memberFieldSettings}
                                    onFilterChange={handleAdvancedFilterChange}
                                    hideApplyButton={true}
                                />
                            )}
                        </> : ""}

                        {props.type === EmailFormType.EmailFormByMember ? <MemberAutocomplete showList={false} AutoCompleteType={AutoCompleteType.Email} onAutoCompleteSelect={onAutoCompleteSelect} listHeader={GetText("ReminderForm_ReminderListHeader")} members={props.memberResult.members} /> : ""}
                        {props.type === EmailFormType.EmailFormByGroup ? <><br /><BookyButton style={{ marginTop: "10px" }} text={GetText("EmailForm_CreateSendList")} onClick={() => onFilterMembers(currentFilterRequest)}></BookyButton></> : ""}
                        {props.type === EmailFormType.EmailFormByExternal ? <><br /> <ContactAutoComplete AutoCompleteType={AutoCompleteType.Email} descriptionText={GetText("AutoComplete_HelpTextAddEmail")} showList listHeader={GetText("EmailForm_ExternalMailHeader")} emails={externalEmails} onEmailsUpdated={onEmailsUpdated} /></> : ""}

                        {selectedMembers.length === 0 ? "" : <MemberTable user={user} memberFieldSettings={memberFieldSettings} isMail={true} members={selectedMembers} style={{ minWidth: '400px', marginTop: "10px" }} removeMember={removeMember} showPaymentLinkColumn={containsPaymentLinkParam(html)} />}
                        {selectedMembers.length > 0 ? <><br /><i>{selectedMembers.length} {GetText("EmailForm_ChosenReceivers")}</i></> : ""}

                        {getMembersWithoutPaymentLink().length > 0 && (
                            <Alert
                                style={{ marginTop: 12 }}
                                type="warning"
                                showIcon
                                icon={<ExclamationCircleFilled style={{ color: '#faad14' }} />}
                                message={GetText("EmailForm_PaymentLinkWarning").replace("{0}", getMembersWithoutPaymentLink().length.toString())}
                                description={
                                    <div style={{ marginTop: 4 }}>
                                        {getMembersWithoutPaymentLink().slice(0, 10).map((m, idx) => (
                                            <div key={m.memberId ?? idx} style={{ padding: '2px 0' }}>
                                                {m.firstName} {m.lastName} {m.email ? `(${m.email})` : ''} {m.uniqueId ? `- ${m.uniqueId}` : ''}
                                            </div>
                                        ))}
                                        {getMembersWithoutPaymentLink().length > 10 && (
                                            <div style={{ padding: '4px 0', fontStyle: 'italic', color: '#888' }}>
                                                {GetText("EmailForm_PaymentLinkWarningMore").replace("{0}", (getMembersWithoutPaymentLink().length - 10).toString())}
                                            </div>
                                        )}
                                        <div style={{ padding: '4px 0', fontStyle: 'italic', color: '#666', marginTop: 4 }}>
                                            {GetText("EmailForm_PaymentLinkSeeTable")}
                                        </div>
                                    </div>
                                }
                            />
                        )}
                    </div>

                    <div style={{
                        backgroundColor: '#fafafa',
                        padding: '20px',
                        borderRadius: '8px',
                        border: '1px solid #e8e8e8'
                    }}>
                        <h3 style={{ marginTop: "0px" }}>{emailIsvalid ? <CheckCircleFilled style={{ color: "green" }} /> : <CheckCircleOutlined style={{ color: "grey" }} />}  {GetText("EmailForm_Step2")}</h3>
                        <Divider style={{ margin: "5px" }} />
                        <BookySelectDropDown allowClear={true} placeholder={GetText("EmailForm_LoadFromEmailTemplate")} handleChange={handleTemplateChange} style={{ width: '400px', marginTop: "20px" }} options={emailTemplatesOptions()}></BookySelectDropDown>
                        <BookyInput onChange={onSubjectchange} label={GetText("EmailForm_Subject")} name="subject" style={{ width: '400px', marginTop: "10px" }} requiredMessage={GetText("EmailForm_SubjectRequired")} ></BookyInput>

                        {/* Workaround to get editor to refresh value */}
                        {initialHtml ? <OneFrontHtmlEditor key={editorKey} hideVariablesMenu={props.type === EmailFormType.EmailFormByExternal} enablePaymentLink={props.enablePaymentLink} initialHtml={initialHtml} onHtmlChange={onHtmlChange} label={GetText("EmailForm_Message")} name="messageFromTemplate" requiredMessage={GetText("EmailForm_MessageRequired")} /> :
                            <OneFrontHtmlEditor key={editorKey} hideVariablesMenu={props.type === EmailFormType.EmailFormByExternal} enablePaymentLink={props.enablePaymentLink} initialHtml={initialHtml} onHtmlChange={onHtmlChange} label={GetText("EmailForm_Message")} name="message" requiredMessage={GetText("EmailForm_MessageRequired")} />}

                        <Form.Item
                            name="upload"
                            label={GetText("EmailForm_AttachFile")}
                        >
                            <FileSelect onFileSelectChange={onFileSelectChange} />
                        </Form.Item>

                        <Form.Item>
                            <Space style={{ width: '100%', justifyContent: 'left', margin: 0 }}>
                                <Button type="primary" htmlType="submit">
                                    {GetText("EmailForm_SendEmailToGroupButtonText")}
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>

                </Form> : <Alert
                    message={GetText("EmailForm_AlertSuspendedMessage")}
                    description={GetText("EmailForm_AlertSuspendedDescription")}
                    type="warning"
                />}
            </> : <span><Tag color="#1890ff">Premium</Tag><a href={"/" + getCurrentLanguage() + "/Pricing"}>{GetText("Common_UpgradeToPremium")}</a>{GetText("EmailForm_PremiumSendingMessageToGroups")}</span>
        }

    </>
}